import { Component, Input, OnInit } from '@angular/core';
import { NavigationItem } from "../../models/navigationItem";
import { LocationNavigationItem } from "../../models/locationNavigationItem";
import { FirebaseService } from "../../providers/firebase.service";
import { FirebaseListObservable } from 'angularfire2/database-deprecated';
import 'rxjs/add/operator/first';
import { isNullOrUndefined } from 'util';
import * as _ from 'lodash';

declare const swal: any;


@Component({
  selector: 'scs-navigation-item',
  templateUrl: './navigation-item.component.html',
  styleUrls: ['./navigation-item.component.css']
})
export class NavigationItemComponent implements OnInit {
  @Input() locationData;
  @Input() clientData;
  @Input() navItems: FirebaseListObservable<NavigationItem[] | LocationNavigationItem[]>;

  navItem: NavigationItem | LocationNavigationItem;
  selectedNavItem: NavigationItem | LocationNavigationItem;
  displayNavItemDialog: boolean;
  newNavItem: boolean;
  sizeGuideRouteIndex = -1;

  constructor(
    public afService: FirebaseService
  ) { }

  async ngOnInit() {
    const data = await this._getNavItems();
    if (this.locationData && data.length === 0) {
      this.generateLocationNavItems();
    }
    else {
      this.sizeGuideRouteIndex = _.findIndex(data, ['route', 'size-guide']);
    }
  }

  generateLocationNavItems() {
    let locationNav = {};
    for (let i in this.clientData.navigation) {
      locationNav[i] = {
        name: this.clientData.navigation[i].name,
        route: this.clientData.navigation[i].route,
      }
    }
    this.afService.saveLocationNavItems(this.clientData.$key, this.locationData.$key, locationNav);
  }

  showNavItemDialogToAdd() {
    this.newNavItem = true;
    this.navItem = new NavigationItem();
    this.displayNavItemDialog = true;
  }

  onNavItemRowSelect(event) {
    this.newNavItem = false;
    this.navItem = event.data;
    this.displayNavItemDialog = true;
    if (isNullOrUndefined(this.navItem.children)) {
      this.navItem.children = [];
    }
  }

  async setDefaults() {
    const items = await this._getNavItems();
    // console.log(items);
    for (let item of items) {
      // console.log(item);
      if (item.isDropDown && item.children) {
        let changed = false;
        for (let child of item.children) {
          if (!child.metaTitle && child.name) {
            changed = true;
            console.log('changing ' + child.name);
            child.metaTitle = child.name + " | " + this.clientData.name;
          }

          if (!child.metaImageAlt && child.name) {
            changed = true;
            console.log('changing ' + child.name);
            child.metaImageAlt = child.name + " | " + this.clientData.name;
          }
        }

        if (changed) {
          await this.afService.updateNavItem(this.clientData, item);
        }
      }
      else {
        let changed = false;
        if (!item.metaTitle && item.name) {
          changed = true;
          console.log('changing ' + item.name);
          item.metaTitle = item.name + " | " + this.clientData.name;
        }

        if (!item.metaImageAlt && item.name) {
          changed = true;
          console.log('changing ' + item.name);
          item.metaImageAlt = item.name + " | " + this.clientData.name;
        }

        if (changed) {
          await this.afService.updateNavItem(this.clientData, item);
        }
      }
    }
    this.afService.openSnackBar('Meta defaults set.');
    console.log('complete');
  }

  async replaceSizeGuideWithDropdown() {
    const confirm = await swal({
      title: 'Are you sure?',
      icon: 'warning',
      buttons: true,
    });

    if (confirm) {
      const data: NavigationItem[] = await this._getNavItems();
      const [canonical, name] = this._getRandomDropdownName();
      const tmp = _.cloneDeep(data[this.sizeGuideRouteIndex]);
      // set it this dumb way to preseve the $key
      data[this.sizeGuideRouteIndex].isDropDown = true;
      data[this.sizeGuideRouteIndex].canonical = canonical;
      data[this.sizeGuideRouteIndex].name = name;
      data[this.sizeGuideRouteIndex].route = null;
      data[this.sizeGuideRouteIndex].children = [
        tmp,
        {
          name: 'Storage Tips',
          route: 'storage-tips',
          external: false,
          topLevel: true,
          isDropDown: false
        },
        {
          name: 'Storage Calculator',
          route: 'storage-calculator',
          external: false,
          topLevel: true,
          isDropDown: false
        },
        {
          name: 'FAQs',
          route: 'faq',
          external: false,
          topLevel: true,
          isDropDown: false
        },
      ];

      await this.afService.updateNavItem(this.clientData, data[this.sizeGuideRouteIndex]);
      // hide the button
      this.sizeGuideRouteIndex = -1;
    }
  }

  setLocationDefaults(choice) {
    if (choice == 'preserve') {
      for (let i in this.locationData.navigation) {
        if (!this.locationData.navigation[i].metaTitle && this.locationData.navigation[i].name) {
          this.locationData.navigation[i].metaTitle = this.locationData.navigation[i].name + " | " + this.locationData.name + " | " + this.clientData.name;
          this.afService.updateNavItem(this.clientData, this.locationData.navigation[i], this.locationData, i);
        }
        if (!this.locationData.navigation[i].metaImageAlt && this.locationData.navigation[i].name) {
          this.locationData.navigation[i].metaImageAlt = this.locationData.navigation[i].name + " | " + this.locationData.name + " | " + this.clientData.name;
          this.afService.updateNavItem(this.clientData, this.locationData.navigation[i], this.locationData, i);
        }
      }
    }

    if (choice == 'overwrite') {
      for (let i in this.locationData.navigation) {
        this.locationData.navigation[i].metaTitle = this.locationData.navigation[i].name + " | " + this.locationData.name + " | " + this.clientData.name;
        this.locationData.navigation[i].metaImageAlt = this.locationData.navigation[i].name + " | " + this.locationData.name + " | " + this.clientData.name;
        this.afService.updateNavItem(this.clientData, this.locationData.navigation[i], this.locationData, i);
      }
    }
  }

  async generateLocationMeta() {
    const value = await swal({
      title: "Overwrite Current Information?",
      text: "Do you want to overwrite current info or only change empty fields?",
      icon: "warning",
      buttons: {

        cancel: "Cancel",

        'Preserve': {
          text: "No, preserve data!",
          value: "preserve"
        },
        'Overwrite': {
          text: "Yes, overwrite data!",
          value: "overwrite"
        }
      }
    });

    switch (value) {
      case "overwrite":
        swal("Deleted!", "Your imaginary info has been deleted.", "success");
        this.setLocationDefaults('overwrite');
        break;
      case "preserve":
        swal("Preserved!", "Your imaginary info has been preserved.", "success");
        this.setLocationDefaults('preserve');
        break;
      default:
        swal("Cancelled", "Your imaginary task has been cancelled.", "warning");
    }
  }


  saveNavItem() {
    if (this.newNavItem == true) {
      this.afService.saveNavItem(this.clientData, this.navItem, this.locationData).then(() => {
        this.afService.openSnackBar('Nav bar item saved.');
      });
    }
    else {
      this.afService.updateNavItem(this.clientData, this.navItem, this.locationData).then(() => {
        this.afService.openSnackBar('Nav bar item saved.');
      }).catch(e => {
        this.afService.openSnackBar(e.message);
      });
    }
    this.navItem = null;
    this.displayNavItemDialog = false;
  }

  deleteNavItem() {
    this.afService.deleteNavItem(this.clientData, this.selectedNavItem).then(() => {
      this.afService.openSnackBar('Nav bar item Deleted.');
    }).catch(e => {
      this.afService.openSnackBar(e.message);
    });
    this.selectedNavItem = null;
    this.displayNavItemDialog = false;
  }

  newChild() {
    if (this.locationData) {
      // @ts-ignore
      this.navItem.children.push(new LocationNavigationItem());
    }
    else {
      // @ts-ignore
      this.navItem.children.push(new NavigationItem());
    }
  }

  deleteChild(index) {
    this.navItem.children.splice(index, 1);
  }

  private _getNavItems(): Promise<NavigationItem[] | LocationNavigationItem[]> {
    return new Promise((resolve, reject) =>
      this.navItems.first()
        .subscribe((data: any) => resolve(data), error => reject(error))
    );
  }

  private _getRandomDropdownName() {
    const pairs = [
      ['resources', 'Resources'],
      ['storage-resources', 'Storage Resources'],
      ['storage-info', 'Storage Info'],
      ['storage-help', 'Storage Help']
    ];

    return pairs[_.random(0, pairs.length - 1)];
  }
}



// WEBPACK FOOTER //
// ./src/ng2/app/components/navigation-item/navigation-item.component.ts